<template>
<Upload 
	:action="url||'/pc/fileServer/upload'" 
	:headers="{
		'is-desensitization':'false'
	}"
	:on-success="uploaded" 
	:on-remove="removeFile"
	:on-format-error="onFormatError"
	ref="upload" 
	:before-upload="beforeFile"
	:show-upload-list="showUploadList"
	:format="format"
	class="upload"
	:data="data">
    <Button icon="ios-cloud-upload-outline" :disabled="disabled" :loading="loading">{{btnText}}</Button>
</Upload>
</template>
<script>
export default {
	props:{
		showUploadList:{
			type:Boolean,
			default:false
		},
		btnText:{
			type:String,
			default:'上传附件'
		},
		accept:String,
		format:{
			type: Array
		},
		data:{
			type:Object,
			default () {
				return {}
			}
		},
		url:String,
		beforeUpload:Function,
		disabled:{
			type:Boolean,
			default:false
		},
		resAll:{
			type:Boolean,
			default:false
		}
	},
	data () {
		return {
			file:'',
			loading:false
		}
	},
	methods:{
		onFormatError (file) {
			this.$Notice.error({
				title: '上传格式有误',
			});
			this.loading = false;
		},
		beforeFile (file) {
			this.$refs['upload'].clearFiles();
			this.loading = true;
			if(file){
				this.$emit('get-file',file)
			}
			if(this.beforeUpload){
				let flag = this.beforeUpload()
				this.loading = flag;
				return flag;
			}
		},
		uploaded (res,file){
			if(this.resAll){
				this.$emit('on-success',res);
				this.$emit('on-file',file);
			}else if(res.code===10000000){
				this.$Notice.success({
		            title: '上传成功',
		            desc: `文件${file.name}上传完成。`
		        });
				this.$emit('on-success',res.data);
				this.$emit('on-file',file);
			}else{
				this.alert(res.msg)
			}
			this.loading = false;
		},
		removeFile (file) {
			this.file = '';
			this.$emit('on-success',this.file)
		},
	}
}
</script>
<style scoped>
	.upload{
		display: inline-block;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/common/UploadFile.vue